import React from 'react'

export default function FaceFeature({ scaleX, fill, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <path
        d="M1.49317 0.142334C1.49317 0.142334 2.15317 15.6623 8.92317 26.7323L5.78317 40.6023C5.78317 40.6023 -0.156825 27.7224 0.00317524 0.972351L1.49317 0.142334Z"
        fill={fill}
      />
      <path
        d="M47.5633 0.142334C47.5633 0.142334 46.9033 15.6623 40.1333 26.7323L43.2733 40.6023C43.2733 40.6023 49.2133 27.7224 49.0533 0.972351L47.5633 0.142334Z"
        fill={fill}
      />
    </g>
  )
}
